let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lhZDC")).then(() => parcelRequire('kapuc'));